import { CARD_FORM } from "../form-card-type";
import { showToast } from "../../../toasts";
import useAuth from "../../../../hooks/auth-hooks";
import { checkForSelectValue } from "../../form-helpers";
import { downloadCSV } from "../csv/download-csv-card";

import AwsPostNewCards from "../../../../routes/post-new-cards";

/**
 * Function to post a new card
 * 
 * @returns void
 */
export const postNewCard = async () => { 
  const { cardForm, cardPartner, cardCustomer, cardCardGroup, cardNames, cardDriverPins, cardSubmitButton } = CARD_FORM;

  const validateForm = () => {
    cardForm.classList.add('was-validated');

    checkForSelectValue(cardPartner, 'Partner', 'partner');
    checkForSelectValue(cardCustomer, 'Customer', 'customer');
    checkForSelectValue(cardCardGroup, 'Card Group', 'card-group');

    return cardForm.checkValidity() &&
        cardPartner.getAttribute('data-value') != null &&
        cardCustomer.getAttribute('data-value') != null &&
        cardCardGroup.getAttribute('data-value') != null;
  }

  const downloadAndRedirect = async (awsData: any) => {
    const { body } = await AwsPostNewCards(awsData);

    if ( body ) {
      showToast('aafp_toast', `Cards have been created. Printer file will download soon.`);
      downloadCSV(body, cardPartner, cardCustomer, cardCardGroup);
      setTimeout(() => {
        location.href = '/cards/';
      }, 1500);
    }
  }

  cardForm.addEventListener('submit', async (e: any) => {
    e.preventDefault();
    e.stopPropagation();    

    if ( validateForm() ) {
      cardForm.classList.remove('form-control:valid');
      cardSubmitButton.classList.add('aafp_button-loading');

      const { userId } = useAuth()!;

      const cardNameList = cardNames.value.replace(/\n/g, '\\n');

      const awsData = {
        wpId: userId,
        partnerId: +cardPartner.getAttribute('data-value')!,
        customerId: +cardCustomer.getAttribute('data-value')!,
        cardGroupId: +cardCardGroup.getAttribute('data-value')!,
        cardNames: cardNameList,
        driverPins: cardDriverPins.value
      };          
          
      await Promise.all([
        showToast('aafp_toast', `Cards have been created. Printer file will download soon.`),
        downloadAndRedirect(awsData)
      ]);                 
    } else {
      console.log('Form is not valid');
    }
  });
};